import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
var _excluded = ["checked", "onChange", "children", "modelElementSelected", "modelPending"];
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ModelSelect/SelectItem/SelectItem.tsx";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { ListItemSecondaryAction } from '@mui/material';
import { Box } from '@gmini/ui-kit/lib/Box';
import { Checkbox } from '@gmini/ui-kit/lib/Checkbox';
import { NumCircle } from "../../../components";
import { IconWrap } from "../ModelSelect.styled";
import { useStyles, Container, SelectItemText, SelectedDot } from "./SelectItem.styled";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var SelectItem = /*#__PURE__*/React.memo(function (_ref) {
  var checked = _ref.checked,
      _onChange = _ref.onChange,
      children = _ref.children,
      modelElementSelected = _ref.modelElementSelected,
      modelPending = _ref.modelPending,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var classes = useStyles();
  var isChild = 'isChild' in otherProps && otherProps.isChild;
  var dependencyIdx = 'dependencyIdx' in otherProps && otherProps.dependencyIdx;
  return /*#__PURE__*/_jsxs(Container, {
    onClick: function onClick() {
      return _onChange(!checked);
    },
    active: checked,
    isChild: isChild,
    disabled: modelPending,
    children: [/*#__PURE__*/_jsx(IconWrap, {
      children: /*#__PURE__*/_jsx(Checkbox, {
        checked: checked,
        onClick: function onClick(e) {
          return e.stopPropagation();
        },
        onChange: function onChange() {
          return _onChange(!checked);
        }
      })
    }), /*#__PURE__*/_jsx(SelectItemText, {
      children: children
    }), /*#__PURE__*/_jsx(Box, {
      ml: 2,
      children: /*#__PURE__*/_jsx(ListItemSecondaryAction, {
        className: classes.listItemSecondaryAction,
        children: /*#__PURE__*/_jsxs(Box, {
          display: "inline-flex",
          alignItems: "center",
          children: [modelElementSelected && /*#__PURE__*/_jsx(SelectedDot, {}), dependencyIdx && /*#__PURE__*/_jsx(Box, {
            ml: 1,
            children: /*#__PURE__*/_jsx(NumCircle, {
              disabled: true,
              children: dependencyIdx
            })
          })]
        })
      })
    })]
  });
});
SelectItem.displayName = 'SelectItem';